<script setup>
  import {mobilityRestriction} from "@pages/Patients/Components/PatientAttributes/Enums.js";

  defineOptions({
    name: "ComponentPatientSidebarMobilityAttribute",
  });

  defineProps({
    attribute: {
      type: Object,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <div :class="{'flex flex-wrap space-x-1.5': inline}">
    <h6 class="text-gray-600" :class="{'font-semibold': inline, 'text-xs uppercase': !inline}">
      Eingeschränkte Mobilität{{ inline ? ":" : "" }}
      <slot name="label" />
    </h6>
    <div :class="{'mt-0.5 text-sm': !inline}">
      <slot>
        <ul>
          <template v-for="(label, key) in mobilityRestriction" :key="key">
            <li v-if="attribute?.payload && attribute?.payload[key]">{{ label }}</li>
          </template>
        </ul>
      </slot>
    </div>
  </div>
</template>
